// @ts-nocheck
import apps from 'temp/brand.json'

export const FACEBOOK_APP_ID = apps.facebook || ''
export const GOOGLE_APP_ID = apps.google || ''
export const APPLE_APP_ID = apps.apple || ''
